<template lang="pug">
img(:src="images[index]")
</template>

<script>
import Animation from "./Animation.vue";
import SL0 from "../assets/courant_example/sl_0.png";
import SL1 from "../assets/courant_example/sl_1.png";
import SL2 from "../assets/courant_example/sl_2.png";
import SL3 from "../assets/courant_example/sl_3.png";
import SL4 from "../assets/courant_example/sl_4.png";
import SL5 from "../assets/courant_example/sl_5.png";
import SL6 from "../assets/courant_example/sl_6.png";
import SL7 from "../assets/courant_example/sl_7.png";
import SL8 from "../assets/courant_example/sl_8.png";
import SL9 from "../assets/courant_example/sl_9.png";

export default {
  mixins: [Animation],
  props: {
    active: { type: Boolean, default: true },
    autoStartAnimation: {
      type: Boolean,
      default: false,
    },
    offset: { type: Number, default: 0 },
  },
  computed: {
    index() {
      return this.active
        ? Math.floor(this.time / 2500) % this.images.length
        : this.offset;
    },
  },
  mounted() {
    if (this.active) this.startAnimation();
  },
  data() {
    return {
      images: [SL0, SL1, SL2, SL3, SL4, SL5, SL6, SL7, SL8, SL9],
    };
  },
  watch: {
    active() {
      if (this.active) this.startAnimation();
      else {
        this.time = 0;
        this.stopAnimation();
      }
    },
  },
};
</script>